import { setSmartStorageItem } from "@/utils/smartStorage";
import axios from "axios";

export interface loginResponse {
    success: boolean;
    user?: {
        id: number;
        username: string;
        role: string;
    };
    token?: string;  // JWT token
    message?: string;
}
export const login = async (username: string, password: string): Promise<loginResponse> => {
    try {
        const response = await axios.post("https://portfoliom-backend.vercel.app/auth/login", { username, password });

        if (response.data?.success) {
            const { user, token } = response.data;

            // Token ve role direkt burada kaydediliyor
            if (token) localStorage.setItem("token", token);
            if (user?.role) setSmartStorageItem("role", user.role, 3600);

            return { success: true, user, token };
        }

        return { success: false, message: response.data.message };
    } catch (err) {
        return { success: false, message: "Giriş sırasında hata oluştu" };
    }
};